
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FrameHelper extends Vue {
  @Prop() disabled !:boolean;
}
